import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initAnalytics } from "./analytics";
import "./styles.css";

initAnalytics();

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
